import React from "react";
import TmsUser from "components/TmsUser/index.func";
import {createRoot} from "react-dom/client";

let app;

export function init(configObject) {
    const tagList = document.querySelectorAll("tms-user");

    for (let i = 0; i < tagList.length; i++) {

        app = createRoot(tagList[i]);
        app.render(<TmsUser />);

    }
}
